import React, { useState, useEffect } from "react";

// Material UI imports
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Grid2,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import PopUpModal from "../../ui-components/PopUpModal";
import UpdatePackage from "./updatePackage";
import AdminDBServices from "../../services/v1/adminDBServices";

// service import

const PackageDetails = () => {
  const [isUpdatePackageOpen, setIsUpdatePackageOpen] = useState(false);
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);

  const fetchPackages = async () => {
    try {
      setLoading(true);
      const response = await AdminDBServices.getAllPackages();
      const packagesData = Array.isArray(response?.data.data) ? response.data.data : [];
      setPackages(packagesData);
    } catch (err) {
      setError("Failed to fetch packages.");
      console.error("Error fetching packages:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPackages();
  }, []);

  return (
    <Grid2 container size={{ xs: 12 }} spacing={2} justifyContent="center">
      {loading ? (
        <Box>
          <CircularProgress color="secondary" />
        </Box>
      ) : error ? (
        <Typography variant="body1" color="error">
          {error}
        </Typography>
      ) : (
        Array.isArray(packages) && packages.length > 0 ? (
          packages.map((packageData, index) => (
          <Grid2 item size={{ xs: 4 }} key={index}>
            <Card
              variant="outlined"
              sx={{ mb: 3, justifyItems: "center", textAlign: "center" }}
            >
              <CardContent>
                <Typography
                  sx={{
                    color: "#8B2757",
                    fontSize: 16,
                    fontWeight: "bold",
                    mt: 2,
                  }}
                >
                  {packageData.title}
                </Typography>
                <Box paddingLeft={2}>
                  <Typography variant="body1" sx={{ fontSize: 15 }}>
                    {packageData.description}
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{ fontWeight: "bold", mt: 3 }}>
                  Rs.
                  {new Intl.NumberFormat("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(packageData.price)}
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  sx={{
                    mb: 2,
                    backgroundColor: "#8B2757",
                    borderRadius: 5,
                  }}
                  variant="contained"
                  onClick={() => {
                    setSelectedPackage(packageData);
                    setIsUpdatePackageOpen(true);
                  }}
                >
                  Update
                </Button>
              </CardActions>
            </Card>
          </Grid2>
        ))
        ) : (
          <Typography variant="body1">
            No packages available
          </Typography>
        )
      )}

      <Box>
        <PopUpModal
          open={isUpdatePackageOpen}
          handleCloseDialog={() => setIsUpdatePackageOpen(false)}
          title="Update Package"
          content={
            <UpdatePackage
              handleCloseDialog={() => setIsUpdatePackageOpen(false)}
              packageData={selectedPackage}
              fetchPackages={fetchPackages}
            />
          }
          maxWidth={600}
        />
      </Box>
    </Grid2>
  );
};

export default PackageDetails;